module.exports = __webpack_public_path__ + "img/DN-Marker-Billboard.4601b25d.svg";